export default {
  // Header
  "dc.header.badge": "Critical Infrastructure",
  "dc.header.back": "Back",
  "dc.header.active": "Active Infrastructure",

  // Hero slides
  "dc.hero.slide1.tag": "Critical Infrastructure",
  "dc.hero.slide1.title": "Datacenter Solutions",
  "dc.hero.slide1.highlight": "& Infrastructure",
  "dc.hero.slide1.subtitle": "Design, implementation and management of mission-critical infrastructure with Tier III+ standards, high availability and N+1 redundancy for your operation.",
  "dc.hero.slide1.cta": "View capabilities",

  "dc.hero.slide2.tag": "High Availability",
  "dc.hero.slide2.title": "N+1 Redundancy",
  "dc.hero.slide2.highlight": "Zero Downtime",
  "dc.hero.slide2.subtitle": "Redundant architecture in power, cooling and connectivity with UPS, generators and dedicated fiber links to ensure 24/7/365 operational continuity.",
  "dc.hero.slide2.cta": "Learn more",

  "dc.hero.slide3.tag": "Physical Security",
  "dc.hero.slide3.title": "Multi-Layer",
  "dc.hero.slide3.highlight": "Physical Protection",
  "dc.hero.slide3.subtitle": "Biometric access control, 24/7 CCTV, environmental monitoring, fire detection and suppression, and permanent security personnel for your infrastructure.",
  "dc.hero.slide3.cta": "View security",

  "dc.hero.viewSolutions": "View Solutions",
  "dc.hero.backHome": "Back to Home",

  // Features section
  "dc.features.tag": "Infrastructure",
  "dc.features.title": "Datacenter",
  "dc.features.highlight": "Capabilities",
  "dc.features.subtitle": "World-class infrastructure with enterprise standards, redundancy and certified security",

  "dc.features.f1.title": "Housing & Colocation",
  "dc.features.f1.desc": "Dedicated spaces in Tier III+ datacenters with private racks, biometric access control and continuous environmental monitoring.",
  "dc.features.f1.stat": "Tier III+",
  "dc.features.f1.statLabel": "Certification",

  "dc.features.f2.title": "Redundant Power",
  "dc.features.f2.desc": "Parallel N+1 UPS systems, diesel generators with extended autonomy and intelligent PDUs with per-circuit metering.",
  "dc.features.f2.stat": "99.995%",
  "dc.features.f2.statLabel": "Availability",

  "dc.features.f3.title": "Precision Cooling",
  "dc.features.f3.desc": "Precision air conditioning systems with hot/cold aisles, thermal monitoring and real-time humidity control.",
  "dc.features.f3.stat": "22 C",
  "dc.features.f3.statLabel": "Optimal Temp",

  "dc.features.f4.title": "Enterprise Connectivity",
  "dc.features.f4.desc": "Dedicated fiber links, multiple carriers, BGP, SD-WAN networks and cross-connects for low-latency interconnection.",
  "dc.features.f4.stat": "+5",
  "dc.features.f4.statLabel": "Carriers",

  "dc.features.f5.title": "Physical Security",
  "dc.features.f5.desc": "Multi-factor biometric access control, 24/7 CCTV recording, mantrap, VESDA fire detection and suppression.",
  "dc.features.f5.stat": "24/7",
  "dc.features.f5.statLabel": "Surveillance",

  "dc.features.f6.title": "Monitoring & Management",
  "dc.features.f6.desc": "Centralized DCIM platform with real-time monitoring of power, temperature, humidity and equipment status with alerts.",
  "dc.features.f6.stat": "< 1min",
  "dc.features.f6.statLabel": "Alert",

  // Soluciones section
  "dc.solutions.tag": "Enterprise Solutions",
  "dc.solutions.title": "Our Data Center",
  "dc.solutions.highlight": "Solutions",
  "dc.solutions.subtitle": "A comprehensive ecosystem of infrastructure and technology services to drive your organization's digital transformation",
  "dc.solutions.viewSolution": "View solution",

  "dc.solutions.s1.title": "Data Center & Infrastructure",
  "dc.solutions.s1.subtitle": "Mission-critical infrastructure with Tier III+ standards, N+1 redundancy and 24/7 environmental monitoring.",
  "dc.solutions.s2.title": "Cloud Services",
  "dc.solutions.s2.subtitle": "Migration and management of hybrid cloud environments with AWS, Azure and Google Cloud. Elastic scalability.",
  "dc.solutions.s3.title": "Security Services",
  "dc.solutions.s3.subtitle": "Comprehensive protection with NGFW firewalls, IDS/IPS, WAF, DLP and data encryption at rest and in transit.",
  "dc.solutions.s4.title": "Networking & Communications",
  "dc.solutions.s4.subtitle": "Enterprise network design with SD-WAN, MPLS, dedicated fiber optics and intelligent load balancing.",
  "dc.solutions.s5.title": "Cybersecurity",
  "dc.solutions.s5.subtitle": "24/7 CyberSOC with Threat Hunting, SIEM, SOAR and threat intelligence with over 200 specialists.",
  "dc.solutions.s6.title": "Managed Services (SOC/NOC)",
  "dc.solutions.s6.subtitle": "Proactive 24/7/365 monitoring from our NOC and SOC with early detection and automated response.",
  "dc.solutions.s7.title": "Databases & Backup",
  "dc.solutions.s7.subtitle": "Oracle, SQL Server, PostgreSQL administration. Backup, replication, high availability and guaranteed DR.",
  "dc.solutions.s8.title": "Business Continuity & Disaster Recovery",
  "dc.solutions.s8.subtitle": "BCP/DRP plans with alternate sites, synchronous replication and periodic testing with measurable RTO/RPO.",
  "dc.solutions.s9.title": "Software/Hardware Sales & Renting",
  "dc.solutions.s9.subtitle": "Enterprise licensing distribution, datacenter hardware and turnkey integrated solutions.",
  "dc.solutions.s10.title": "Project Consulting",
  "dc.solutions.s10.subtitle": "Professional services with agile and PMI methodologies for IT project design and execution.",

  // CTA
  "dc.cta.tag": "Activate Datacenter",
  "dc.cta.title": "Protect your infrastructure with",
  "dc.cta.subtitle": "World-class infrastructure with guaranteed availability, 24/7 physical security and specialized support",
  "dc.cta.button": "Request free assessment",
  "dc.cta.homeButton": "View main site",
};